/**
 * Pagination limit for school list queries.
 *
 * Defines the maximum number of schools to fetch per page
 * for school list views in the application.
 *
 * @constant SCHOOL_LIMIT - Maximum schools to show per page (9 for 3x3 grid layout)
 */
export const SCHOOL_LIMIT = 9;
